export default "__VITE_ASSET__B_VpWGT1__"